/* import __COLOCATED_TEMPLATE__ from './fin-suffix.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import type Store from '@ember-data/store';
import type IntlService from 'embercom/services/intl';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { enqueueTask } from 'ember-concurrency-decorators';
import type { TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import { captureException } from 'embercom/lib/sentry';

interface Args {
  settings: $TSFixMe;
}

export default class FinSuffix extends Component<Args> {
  @service declare store: Store;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare intercomEventService: $TSFixMe;

  @enqueueTask
  *updateSetting(): TaskGenerator<void> {
    try {
      yield this.args.settings.save();

      this.trackUpdateAnalytics();

      this.notificationsService.notifyConfirmation(
        this.intl.t('channels.email.settings.update_success'),
      );
    } catch (error) {
      captureException(error, {
        tags: {
          component: 'FinSuffix',
          action: 'updateSetting',
        },
        extra: {
          errorResponse: error.errors,
        },
      });
      this.trackAnalytics('error');
      this.args.settings.toggleProperty('showAiAgentSuffix');
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('channels.email.settings.update_failure'),
      });
    }
  }

  @action
  toggleFinSuffixSettings() {
    this.args.settings.toggleProperty('showAiAgentSuffix');
    taskFor(this.updateSetting).perform();
  }

  trackUpdateAnalytics() {
    let action = this.args.settings.showAiAgentSuffix ? 'turned_on' : 'turned_off';
    this.trackAnalytics(action);
  }

  trackAnalytics(action: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action,
      object: 'fin_suffix_settings',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Messenger::FinSuffix': typeof FinSuffix;
  }
}
